import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo106",
  "use": "icon-icon-todo106-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo106\"><path d=\"M607.905 616.654v65.906h-63.99v-65.906l-49.295 64.084-50.72-39.016 67.033-87.142h-52.338v-63.99h85.32v-21.33H469.26V319.95h213.3v149.31h-74.655v21.33h85.32v63.99h-52.338l67.033 87.142-50.72 39.016-49.295-64.084zM173.412 186.461l319.95-96.954a63.99 63.99 0 0 1 37.116 0l319.95 96.954c26.98 8.176 45.432 33.048 45.432 61.24V597.24c0 159.811-128.579 272.805-375.522 340.153l-8.418 2.296-8.418-2.296C256.559 870.045 127.98 757.05 127.98 597.24V247.701c0-28.192 18.451-53.064 45.432-61.24zM191.97 597.24c0 123.006 103.373 215.412 319.95 276.09 216.577-60.678 319.95-153.084 319.95-276.09V247.701l-319.95-96.954L191.97 247.7V597.24z m170.64-136.057l-20.036 20.036-45.248-45.248L426.6 306.697V682.56h-63.99V461.183z m170.64-77.243v21.33h85.32v-21.33h-85.32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo106.svg
// module id = 0uRP
// module chunks = 3